import React from 'react';
import { ShieldAlert, Home, User, Briefcase, KeyRound } from 'lucide-react';
import { useApp } from '../../context/AppContext';

export const AdminAccessDenied: React.FC = () => {
  const { navigateTo, currentUser } = useApp();

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-4">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8 sm:p-10 max-w-md w-full text-center space-y-6 shadow-2xl animate-fade-in">
        <div className="w-16 h-16 rounded-3xl bg-rose-500/10 border border-rose-500/30 text-rose-400 flex items-center justify-center mx-auto">
          <ShieldAlert className="w-8 h-8" />
        </div>

        <div className="space-y-2">
          <h2 className="text-xl font-black text-white tracking-tight">
            Access Denied: Admin Privileges Required
          </h2>
          <p className="text-xs text-slate-400 leading-relaxed">
            The JobMatch NG Administrator Control Centre is restricted to verified system administrators. Your account does not have permission to view this console.
          </p>
        </div>

        <div className="p-4 bg-slate-950/80 border border-slate-800 rounded-2xl text-xs space-y-1.5 text-left font-mono">
          <div className="flex justify-between text-slate-400">
            <span>Current User:</span>
            <span className="text-white font-bold">{currentUser?.fullName || 'Guest / Unauthenticated'}</span>
          </div>
          <div className="flex justify-between text-slate-400">
            <span>Role:</span>
            <span className="text-rose-400 uppercase font-bold">{currentUser?.role || 'None'}</span>
          </div>
          <div className="flex justify-between text-slate-400">
            <span>Required Role:</span>
            <span className="text-emerald-400 uppercase font-bold">ADMIN</span>
          </div>
        </div>

        <div className="space-y-2.5 pt-2">
          {currentUser?.role === 'customer' && (
            <button
              onClick={() => navigateTo('customer_dashboard')}
              className="w-full py-3 bg-emerald-500 hover:bg-emerald-600 text-slate-950 text-xs font-bold rounded-xl transition-colors flex items-center justify-center gap-2 cursor-pointer shadow-lg shadow-emerald-500/20"
            >
              <User className="w-4 h-4" />
              <span>Go to Customer Dashboard</span>
            </button>
          )}

          {currentUser?.role === 'professional' && (
            <button
              onClick={() => navigateTo('pro_dashboard')}
              className="w-full py-3 bg-emerald-500 hover:bg-emerald-600 text-slate-950 text-xs font-bold rounded-xl transition-colors flex items-center justify-center gap-2 cursor-pointer shadow-lg shadow-emerald-500/20"
            >
              <Briefcase className="w-4 h-4" />
              <span>Go to Professional Dashboard</span>
            </button>
          )}

          <button
            onClick={() => navigateTo('admin_auth')}
            className="w-full py-2.5 bg-slate-800 hover:bg-slate-700 text-slate-200 text-xs font-bold rounded-xl transition-colors flex items-center justify-center gap-2 cursor-pointer border border-slate-700"
          >
            <KeyRound className="w-4 h-4 text-emerald-400" />
            <span>Sign In with Admin Account</span>
          </button>

          <button
            onClick={() => navigateTo('home')}
            className="w-full py-2.5 text-slate-400 hover:text-slate-200 text-xs font-semibold rounded-xl transition-colors flex items-center justify-center gap-2 cursor-pointer"
          >
            <Home className="w-4 h-4" />
            <span>Return to Public Homepage</span>
          </button>
        </div>
      </div>
    </div>
  );
};
